module.exports = __webpack_public_path__ + "static/storage-link-eed3a0ae98f972e0a83d74063063063b.png";